import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

const DeleteConfirmationModal = ({ closeDeleteConfirmationModal , deleteConfirmationModal , handleDeleteConfirmationModal, deleteCustomer , showError}) => {

    const handleInput = () => {
        let value = !deleteConfirmationModal.checked;
        handleDeleteConfirmationModal(value);
    }
    const startDeleteCustomer = () => {
        let value = deleteConfirmationModal.checked;
        if(value){
            deleteCustomer()
        }else {
            showError();
        }
    }

    return (
        <ReactModal
            isOpen={deleteConfirmationModal.open}
            className="confirmation-modal"
            overlayClassName="confirmation-modal-overlay"
            onRequestClose={closeDeleteConfirmationModal}
            contentLabel= 'Delete Confirmation' >

            <div className="confirmation-modal-content">

                <div className='confirmation-modal-header'>
                    <button type="button" className="close confirmation-modal-button" style={{'padding-right': '10px'}} onClick={closeDeleteConfirmationModal}>&times;</button>
                    <div className="confirmation-modal-title">
                            Delete Patient
                    </div>
                </div>

                <div className="confirmation-modal-body">
                    <div className='confirmation-modal-text'>
                        Information about this patient will be deleted. Are you sure you want to proceed?
                    </div>
                    <form>
                        <label className="confirmation-modal-label">
                            <input
                                name="confirm"
                                type="checkbox"
                                style={{ 'margin-right': '10px'}}
                                checked={deleteConfirmationModal.checked}
                                onClick={handleInput} />
                              I confirm that I want to delete this patient
                        </label>
                    </form>
                    <div>
                    { deleteConfirmationModal.warning ? <div className="confirmation-modal-warning">Must be selected for the patient to be deleted</div> : null }
                    </div>
                </div>

                <div className="confirmation-modal-footer">
                    <button type="button" className="btn btn-default" style={{ 'margin-right': '10px'}} onClick={closeDeleteConfirmationModal}>Close</button>
                    <button type="button" className="btn btn-danger" onClick={startDeleteCustomer}>Delete</button>
                </div>
            </div>

        </ReactModal>

    )
}

DeleteConfirmationModal.propTypes = {
    closeDeleteConfirmationModal: PropTypes.func.isRequired,
    deleteConfirmationModal: PropTypes.object.isRequired,
    handleDeleteConfirmationModal: PropTypes.func.isRequired,
    deleteCustomer: PropTypes.func.isRequired,
    showError: PropTypes.func.isRequired,
}

export default DeleteConfirmationModal



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/DeleteConfirmationModal.js